import { useTranslation } from 'react-i18next'

import { Alert } from '@enechain/ecloud-designsystem'

type Props = {
  /** エラーのある行数 (Check 応答の値)。 */
  count: number
}

/**
 * CSV アップロード Step2 のエラー警告バナー (common.md AC-DUC-014、 design
 * `#error-banner`)。 文言は AC が data type 横断で固定するので `common:` から解決する
 * (page 別 key に複製しない。 `CsvUploadNoopBanner` と同じ)。 エラー行が無い時は出さない。
 */
export const CsvUploadErrorBanner = ({
  count,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (count === 0) return null
  return (
    <Alert
      status="error"
      title={t('common:upload.rowErrors.banner', { count })}
    />
  )
}
